import React from "react";
import { Card, Text, Space, Center, Button } from "@mantine/core";
import DateCarousel from "./DateCarousel";

const DateSelectionCard = (props: {
    currentHotel: any;
    selectedCure: any;
    dateSelect: any;
    handleDateSelected: (key: any, start_date: string, price: number) => void;
    handleOnClick: () => void;
    isMobile: boolean;
    // optionnel : bornes (début inclus, fin EXCLUSIVE) si DateCarousel veut en tenir compte
    startStr?: string;    // "YYYY-MM-DD"
    endExclStr?: string;  // "YYYY-MM-DD"
}) => {
    // console.log(props.currentHotel?.id);

    return (
        <>
            <Card.Section className={"top-card-title"}>
                {/* libellé corrigé */}
                <Text align="center">Sélectionnez votre date d’arrivée</Text>
            </Card.Section>

            <DateCarousel
                priceBedroom={props.selectedCure?.MinPriceBedroom}
                availability={props.currentHotel?.Avaibility}
                selectedCure={props.selectedCure}
                dateSelect={props.dateSelect}
                handleDateSelected={props.handleDateSelected}
                allProduct={props.currentHotel?.Products}
                nbNight={props.selectedCure?.NbNight ?? props.selectedCure?.nights}
                Petitdej={props.currentHotel?.Petitdej}
                // si ton DateCarousel accepte ces props, passe-les pour borner l’affichage
                startStr={props.startStr}
                endExclStr={props.endExclStr}
            />

            {props.dateSelect.isSelect && (
                <div
                    style={
                        props.isMobile
                            ? { position: "fixed", bottom: 0, left: 0, right: 0, backgroundColor: "white" }
                            : {}
                    }
                >
                    <Space h="xl" />
                    <Center>
                        <Button
                            className={"night-nav-active"}
                            uppercase
                            onClick={() => {
                                if (props.dateSelect.isSelect) {
                                    props.handleOnClick();
                                } else {
                                    alert("Veuillez choisir une date");
                                }
                            }}
                        >
                            Continuer
                        </Button>
                    </Center>
                    <Space h="xl" />
                </div>
            )}
        </>
    );
};

export default DateSelectionCard;
